import { render, staticRenderFns } from "./SaleLayoutList.vue?vue&type=template&id=288008c8"
import script from "./SaleLayoutList.vue?vue&type=script&lang=ts"
export * from "./SaleLayoutList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('288008c8')) {
      api.createRecord('288008c8', component.options)
    } else {
      api.reload('288008c8', component.options)
    }
    module.hot.accept("./SaleLayoutList.vue?vue&type=template&id=288008c8", function () {
      api.rerender('288008c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-sales/SaleLayoutList.vue"
export default component.exports